import {AfterContentInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {
  GetIntervenantListingGQL,
  GetOuvrageListingGQL,
  GetOuvrageListingQueryVariables,
} from "../../../../graphql/generated";
import {map} from "rxjs";
import {extractEdgesAndNodes} from "../../graphql/operators/extract-edges-and-nodes";
import {Table, TableModule} from "primeng/table";
import {ClassdefinitionService} from "../../services/classdefinition.service";
import {Router} from "@angular/router";
import {Classdefinition} from "../../model/classdefinition";
import {isArray} from "@apollo/client/utilities";

@Component({
  selector: 'app-list-ouvrage',
  templateUrl: './list-ouvrage.component.html',
  styleUrls: ['./list-ouvrage.component.scss']
})
export class ListOuvrageComponent implements OnInit {

  totalRecords: any = 0
  ouvrages: any
  dataLoaded: boolean = false

  loading: boolean = true

  @ViewChild('dt') table: Table;

  classDef: Classdefinition

  // @ViewChild('filter') filter: ElementRef;

  constructor(
    private service: GetOuvrageListingGQL,
    private classDefinition: ClassdefinitionService,
    private intervenantService: GetIntervenantListingGQL,
    private router: Router
  ) {
    // this.ouvrages = service.fetch().pipe(
    //         map(result => result.data.getOuvrageListing),
    //         extractEdgesAndNodes(),
    //         tap(departments => this.store.departments$.next(departments)),
    //     );
  }

  ngOnInit() {
    this.classDefinition.load().then(() => {
      this.classDef = this.classDefinition.getByName('BaseArticle')
    });
  }

  clear(table: Table) {
    table.clear();
    // this.filter.nativeElement.value = '';
  }

  goToRessourcesNumeriques(id: string) {
    this.router.navigate(['/ressources_numeriques', id])
  }

  getLabelValues(values, field) {
    var valuesArrayFormatted: Array<string> = []
    var self = this

    if (
      typeof this.classDef !== 'undefined' &&
      values !== null &&
      field !== null
    ) {
      values.forEach(function (value) {
        var label = self.classDef.fdef[field]['optionsLabel'][value]
        if (label) {
          label = label.toString().trim().replace(/^,/, '')
          valuesArrayFormatted.push(label)
        }
      });
      return valuesArrayFormatted.join(',').replace(/^,/, '')
    }

    return null
  }

  getOptions(field) {
    if (typeof this.classDef !== 'undefined') {
      return this.classDef.fdef[field].options
    }

    return null
  }

  getOptionsLabel(field, value) {
    if (typeof this.classDef !== 'undefined') {
      const options = this.classDef.fdef[field].options;
      const match = options.find(opt => opt.value === value);
      return match ? match.key : value; // ou retourne null/''
    }
    return value;
  }


  loadDatas($event) {

    var filters = $event.filters
    var keepedFilters = {}
    for (const key in filters) {
      if (filters[key].value !== null && filters[key].value !== '') {
        var extractedValue = this.extraireFiltres(key);
        if (extractedValue !== null) {
          keepedFilters[extractedValue] = filters[key].value;
        }
      }
    }

    var filterJson = {};
    for (const keepedFilter in keepedFilters) {
      filterJson[keepedFilter] = {}
      filterJson[keepedFilter]['$like'] = '%' + keepedFilters[keepedFilter] + '%'
    }

    var filterString = Object.entries(filterJson).length > 0 ? JSON.stringify(filterJson) : null

    const variables: GetOuvrageListingQueryVariables = {
      first: $event.rows,
      after: $event.first,
      filter: filterString
    }

    var datas = this.service.watch(variables).valueChanges

    datas.pipe(
      map(result => result)
    ).subscribe({
        next: value => {
          this.totalRecords = value.data.getOuvrageListing ? value.data.getOuvrageListing.totalCount : 0;
        },
        error: err => {

        }

      }
    )

    datas.pipe(
      map(result => result.data.getOuvrageListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          this.ouvrages = this.remplaceFullIntervenantName(value)
          this.dataLoaded = true
          this.loading = false
        },
        error: err => {
        }
      }
    )
  }

  private extraireFiltres(chaine) {
    // Découper la chaîne en un tableau en utilisant le point comme séparateur
    const parties = chaine.split('.');

    // Initialiser les variables table et champ
    let table = "";
    let champ = "";

    if (parties.length >= 2) {
      // Récupérer les deux dernières parties
      table = parties[parties.length - 2];
      champ = parties[parties.length - 1];

      return table + '.' + champ
    } else if (parties.length === 1) {
      champ = parties[parties.length - 1];
      // Si la chaîne contient une seule partie, la mettre dans champ
      return champ
    }

    return null;
  }

  private remplaceFullIntervenantName(value: any) {
    value.forEach((ouvrage: any) => {
      const assistantEdito = ouvrage.BaseArticle?.AssistantEdito;
      if (assistantEdito) {
        this.intervenantService.fetch({filter: JSON.stringify({code: assistantEdito})}).subscribe({
          next: editeurInterne => {
            if (editeurInterne.data.getIntervenantListing?.edges && isArray(editeurInterne.data.getIntervenantListing?.edges)) {
              if (editeurInterne.data.getIntervenantListing?.edges[0]?.node) {
                ouvrage.BaseArticle.AssistantEdito = editeurInterne.data.getIntervenantListing?.edges[0]?.node?.display_name;
              }
            }
          }
        });
      }

      const editeur = ouvrage.BaseArticle?.EditeurInterne;
      if (editeur) {
        this.intervenantService.fetch({filter: JSON.stringify({code: editeur})}).subscribe({
          next: editeurInterne => {
            if (editeurInterne.data.getIntervenantListing?.edges && isArray(editeurInterne.data.getIntervenantListing?.edges)) {
              if (editeurInterne.data.getIntervenantListing?.edges[0]?.node) {
                ouvrage.BaseArticle.EditeurInterne = editeurInterne.data.getIntervenantListing?.edges[0]?.node?.display_name;
              }
            }
          }
        });
      }
    });
    return value;
  }
}
